import React, { useContext } from "react";
import { Button, ButtonContext, ButtonProps, Spinner, XStack } from "tamagui";

import { getThemedIcon } from "../helpers";

export interface OutlinedButtonProps extends ButtonProps {
  /**
   * Round the button corners.
   * @default false
   */
  rounded?: boolean;
  /**
   * Show a spinner while the button is loading. Also disables the button.
   * @default false
   */
  loading?: boolean;
}

export const OutlinedButton = ({
  rounded,
  loading,
  icon,
  fontSize,
  gap = "$3.5",
  children,
  ...rest
}: OutlinedButtonProps) => {
  const { color } = useContext(ButtonContext);
  const iconElement = icon && getThemedIcon(icon, { size: "$1.5", color });

  return (
    <Button
      variant="outlined"
      borderRadius={rounded ? "$12" : undefined}
      borderWidth={1}
      borderColor="$hgPrimaryGradientStart"
      hoverStyle={{ borderColor: "$info" }}
      pressStyle={{ borderColor: "$hgPrimaryGradientEnd" }}
      disabled={loading}
      {...rest}
    >
      {icon ? (
        <XStack width="100%" gap={gap} alignItems="center">
          <XStack alignItems="center" justifyContent="center">
            {iconElement}
          </XStack>
          {children && (
            <Button.Text fontSize={fontSize}>{children}</Button.Text>
          )}
        </XStack>
      ) : typeof children === "string" ? (
        <Button.Text fontSize={fontSize}>{children}</Button.Text>
      ) : (
        children
      )}
      {loading && <Spinner size="small" color="$color12" />}
    </Button>
  );
};
